import { useEffect } from 'react';

import { useOneRosterAuthQuery } from '@/hooks/useOneRosterAuthQuery';

function parseBlockRedirect(raw: string | undefined): string[] {
  if (!raw) return [];
  return raw
    .replace(/[[\]'"]/g, '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

export function AlphaRedirectGuard() {
  const { data } = useOneRosterAuthQuery();
  const actualEmail = data?.user?.email;

  const blockList = parseBlockRedirect(import.meta.env.VITE_BLOCK_REDIRECT);
  const shouldBlock =
    actualEmail && blockList.some((sub) => actualEmail.includes(sub));

  useEffect(() => {
    if (data?.isAuthenticated && actualEmail && !shouldBlock) {
      window.location.replace('https://alpha.timeback.com');
    }
  }, [data?.isAuthenticated, actualEmail, shouldBlock]);

  return null;
}
